import React, {Component} from "react";
import JobRightView from "../views/JobRightView";
import withError from "../withError";

class JobRightController extends Component {
  constructor(props) {
    super(props);
  }

  render() {

    return <JobRightView  {...this.props}/>;
  }
}


export default withError(JobRightController);
